// In App.js in a new project

import * as React from "react";
import { View, Text, Image, Linking, Dimensions } from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import { createDrawerNavigator } from "@react-navigation/drawer";
import Login from "../page/login/index";
import redirect from "../page/redirect";
import Home from "../page/home/index";
import Competition from "../page/competition/index";
import CompetitionCreate from "../page/CompetitionCreate/index";
import CompetitionEdit from "../page/CompetitionEdit/index";
import CompetitionAthlete from "../page/CompeAthlete/index";
import CompetitionStatus from "../page/CompeCountriesStatus/index";
import PrelimSub from "../page/CompeCountriesStatus/PrelimSub/index";
import FinalSub from "../page/CompeCountriesStatus/FinalSub/index";
import Athlete from "../page/athlete/index";
import Countries from "../page/countries/index";
import ConpeInformation from "../page/conpeInformation";
import CountriesAdd from "../page/countriesAdd/index";
import CountriesEdit from "../page/countriesEdit/index";
import HomeUser from "../pageUser/home/index";
import InfoGuest from "../pageUser/InfoGuest/index";
import CompetitionUser from "../pageUser/competition/index";
import Condition from "../pageUser/Condition/index";
import PrelimEntry from "../pageUser/PrelimEntry/index";
import PrelimEntryCheck from "../pageUser/PrelimEntryCheck/index";
import FinalEntryUser from "../pageUser/FinalEntry/index";
import FinalEntryAthlete from "../pageUser/FinalEntryAthlete/index";
import FinalEntryAthleteEdit from "../pageUser/FinalEntryAthleteII/index";
import AthleteUser from "../pageUser/Athlete/index";
import MenuAdmin from "../component/menuAdmin";
import MenuUser from "../component/menuUser";
import InfoGuestAdmin from "../page/InfoGuest";
import { useRecoilState } from "recoil";
import { tokenState, userState, winds } from "../reducer/recoil";

function debounce(fn, ms) {
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

const Stack = createStackNavigator();
function main() {
  const [token, setToken] = useRecoilState(tokenState);
  const [dimensions, setDimensions] = useRecoilState(winds);

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, 1000);

    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  return (
    <Stack.Navigator
      initialRouteName={
        token == ""
          ? "Login"
          : token.user !== undefined && token.user.role == "Admin"
          ? "Home"
          : "HomeUser"
      }
      headerMode="none"
      mode="modal"
    >
      <Stack.Screen name="Login" component={Login} />
      <Stack.Screen name="Home" component={Home} />
      <Stack.Screen name="redirect" component={redirect} />
      <Stack.Screen name="HomeUser" component={HomeUser} />
      <Stack.Screen name="Competition" component={Competition} />
      <Stack.Screen name="CompetitionCreate" component={CompetitionCreate} />
      <Stack.Screen name="CompetitionEdit" component={CompetitionEdit} />
      <Stack.Screen name="CompetitionAthlete" component={CompetitionAthlete} />
      <Stack.Screen name="CompetitionStatus" component={CompetitionStatus} />
      <Stack.Screen name="PrelimSub" component={PrelimSub} />
      <Stack.Screen name="FinalSub" component={FinalSub} />
      <Stack.Screen name="Athlete" component={Athlete} />
      <Stack.Screen name="Countries" component={Countries} />
      <Stack.Screen name="ConpeInformation" component={ConpeInformation} />
      <Stack.Screen name="CountriesAdd" component={CountriesAdd} />
      <Stack.Screen name="CountriesEdit" component={CountriesEdit} />
      <Stack.Screen name="Entersite" component={HomeUser} />
      <Stack.Screen name="InfoGuest" component={InfoGuest} />
      <Stack.Screen name="InfoGuestAdmin" component={InfoGuestAdmin} />
      <Stack.Screen name="CompetitionUser" component={CompetitionUser} />
      <Stack.Screen name="Condition" component={Condition} />
      <Stack.Screen name="PrelimEntry" component={PrelimEntry} />
      <Stack.Screen name="PrelimEntryCheck" component={PrelimEntryCheck} />
      <Stack.Screen name="FinalEntryUser" component={FinalEntryUser} />
      <Stack.Screen name="FinalEntryAthlete" component={FinalEntryAthlete} />
      <Stack.Screen
        name="FinalEntryAthleteEdit"
        component={FinalEntryAthleteEdit}
      />
      <Stack.Screen name="AthleteUser" component={AthleteUser} />
    </Stack.Navigator>
  );
}

const DrawerStack = createDrawerNavigator();
function Drawer() {
  return (
    <DrawerStack.Navigator
      edgeWidth={0}
      drawerStyle={{
        width: "70%",
      }}
      headerMode="none"
      initialRouteName={"Home"}
      drawerContent={(props) => <MenuAdmin {...props} />}
    >
      <DrawerStack.Screen name="main" component={main} />
    </DrawerStack.Navigator>
  );
}
function DrawerUser() {
  return (
    <DrawerStack.Navigator
      edgeWidth={0}
      drawerStyle={{
        width: "70%",
      }}
      headerMode="none"
      initialRouteName={"Home"}
      drawerContent={(props) => <MenuUser {...props} />}
    >
      <DrawerStack.Screen name="main" component={main} />
    </DrawerStack.Navigator>
  );
}
function web() {
  const [token, setToken] = useRecoilState(tokenState);
  const config = {
    screens: {
      main: {
        path: "main",
        screens: {
          Home: "/Home",
          Login: "/LOGIN",
          Competition: "/COMPETITION",
          CompetitionCreate: "/COMPI-ADD-I",
          CompetitionCreate: "/COMPI-EDIT",
          CompetitionAthlete: "/COMPE/ATHLETE-I",
          CompetitionStatus: "/COMPE/COUNTRIES-STATUS",
          PrelimSub: "/PRELIM-SUB",
          FinalSub: "/FINAL-SUB",
          Athlete: "/ATHLETE",
          Countries: "/COUNTRIES",
          ConpeInformation: "/CONPE-INFORMATION-III",
          CountriesAdd: "/COUNTRY-ADD",
          CountriesEdit: "/COUNTRY-EDIT",
          HomeUser: "/",
          InfoGuest: "/COMPE-INFO",
          CompetitionUser: "/COMPE-USER",
          Condition: "/CONDITION",
          PrelimEntry: "/PRELIM-ENTRY",
          PrelimEntryCheck: "/PRELIM-ENTRY-CHECK",
          FinalEntryUser: "/FINAL-ENTRY",
          FinalEntryAthlete: "/FINAL-ENTRYE-Athlete-I",
          FinalEntryAthleteEdit: "/FINAL-ENTRYE-Athlete-II",
          AthleteUser: "/ATHLETE-II",
          CompetitionEdit: "CompetitionEdit",
          redirect: "prelim-page",
        },
      },
    },
  };
  const linking = {
    prefixes: [
      "https://www.asianAthleticsAssociation.com/",
      "asianAthleticsAssociation://",
    ],
    config,
  };

  return (
    <NavigationContainer linking={linking} fallback={<Text>Loading...</Text>}>
      {token.user !== undefined && token.user.role == "Admin"
        ? Drawer()
        : DrawerUser()}
    </NavigationContainer>
  );
}

export default web;
